import React from "react";
import { useUser } from "../../../../context/AuthContext";
import Scope3ApprovalListCore from "../Scope3ApprovalListCore";
import SimpleScope3ApprovalDrawer from "../SimpleScope3ApprovalDrawer";

const mapFuelEnergyApprovalRow = (item) => ({
  ...item,
  resaleQuantity:
    item?.purchasedElectricityForResale?.resoldQuantity ?? 0,
});

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

const formatConsumptionPeriod = (period) => {
  const month = MONTHS[Number(period?.month) - 1];
  return month && period?.year ? `${month} ${period.year}` : "-";
};

const formatQuantity = (value) => {
  if (value === undefined || value === null || value === "") return "-";
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? String(value) : "-";
};

const fuelValue = (record, key) =>
  record?.purchasedFuels?.[key] ??
  (key === "petroleumGasoline"
    ? record?.purchasedFuels?.petrolOrGasoline
    : undefined);

const buildFuelEnergyApprovalFields = (data) => {
  const requested = data?.editValue || {};
  const field = (label, previous, next) => ({
    label,
    previous,
    requested: next,
  });
  const quantityField = (label, getValue) =>
    field(label, formatQuantity(getValue(data)), formatQuantity(getValue(requested)));

  return [
    field(
      "Consumption Period",
      formatConsumptionPeriod(data?.consumptionPeriod),
      formatConsumptionPeriod(requested?.consumptionPeriod),
    ),
    quantityField("Natural Gas", (record) => fuelValue(record, "naturalGas")),
    quantityField("Coal", (record) => fuelValue(record, "coal")),
    quantityField("Petrol", (record) => fuelValue(record, "petroleumGasoline")),
    quantityField("Diesel", (record) => fuelValue(record, "diesel")),
    quantityField("Fuel Oil", (record) => fuelValue(record, "fuelOil")),
    quantityField("LPG", (record) => fuelValue(record, "lpg")),
    quantityField("Propane", (record) => fuelValue(record, "propane")),
    quantityField("CNG", (record) => fuelValue(record, "cng")),
    quantityField("Heating and Cooling", (record) =>
      fuelValue(record, "heatingAndCooling"),
    ),
    quantityField("Steam", (record) => fuelValue(record, "steam")),
    quantityField("Purchased Electricity", (record) =>
      record?.purchasedElectricity?.electricity,
    ),
    quantityField("Transmission and distribution losses - Electricity", (record) =>
      record?.transmissionAndDistributionLosses?.electricity,
    ),
    field(
      "Have you purchased electricity for Resale this month?",
      data?.purchasedElectricityForResale?.purchased ? "Yes" : "No",
      requested?.purchasedElectricityForResale?.purchased ? "Yes" : "No",
    ),
    quantityField("Purchased Electricity Resold Quantity", (record) =>
      record?.purchasedElectricityForResale?.resoldQuantity,
    ),
  ];
};

const FuelEnergyActivitiesView = (props) => (
  <SimpleScope3ApprovalDrawer
    {...props}
    title="Fuel and Energy Related Activities - change request"
    buildApprovalFields={buildFuelEnergyApprovalFields}
  />
);

const FuelEnergyActivitiesApproval = () => {
  const { user } = useUser();
  const canViewCompanyRequests =
    user?.companyAdmin || user?.groupManager || user?.facilityManger;
  const headings = [
    { title: "Date", key: "createdAt" },
    canViewCompanyRequests ? { title: "Facility", key: "facilityName" } : null,
    { title: "Consumption Period", key: "consumptionPeriod" },
    {
      title: "Purchased Electricity for Resale",
      key: "resaleQuantity",
    },
    { title: "Status", key: "requestStatus" },
    { title: "Created By", key: "createdBy" },
  ].filter(Boolean);

  return (
    <Scope3ApprovalListCore
      pageTitle="Fuel and Energy Related Activities"
      apiSegment="fuelEnergyActivities"
      ViewPage={FuelEnergyActivitiesView}
      headings={headings}
      mapRow={mapFuelEnergyApprovalRow}
      columnWidth={
        canViewCompanyRequests
          ? "11% 14% 18% 21% 14% 13%"
          : "14% 23% 25% 17% 13%"
      }
    />
  );
};

export default FuelEnergyActivitiesApproval;
